if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.cartDrawer = document.querySelector('cart-drawer');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();
      this.submitBtn = this.querySelector('[name="add"]');
      if (!this.submitBtn || this.submitBtn.disabled || this.submitBtn.getAttribute('aria-disabled') === 'true') return;
      const selectedVariantInput = this.form.querySelector('[name="id"]');
      if (selectedVariantInput?.dataset.variantPrice === '0') {
        this.setErrorMsgState(selectedVariantInput.dataset.priceUnavailable);
        return;
      }

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      clearTimeout(this.successTimer);
      this.submitBtn.classList.remove('is-success');
      this.errorMsg = null;
      this.setErrorMsgState();
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      let addConfirmed = false;
      let responseError;

      try {
        const formData = new FormData(this.form);
        const sections = ['cart-icon-bubble'];
        if (this.cartDrawer) {
          sections.push(this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', ''));
        }

        formData.set('sections_url', window.location.pathname);
        formData.set('sections', sections.join(','));

        const response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });
        const data = await response.json();

        if (!response.ok || data.status) {
          responseError = typeof data.description === 'string' ? data.description : data.message;
          if (data.errors) {
            responseError = typeof data.errors === 'object'
              ? Object.values(data.errors).flat().join(', ')
              : data.errors;
          }
          throw new Error(response.status);
        }

        const addedItems = Array.isArray(data.items) ? data.items : [data];
        if (!addedItems.length || addedItems.some((item) => !item.variant_id || !(item.quantity > 0))) {
          throw new Error('Invalid add response');
        }

        addConfirmed = true;
        this.dispatchCartEvents(addedItems, formData);

        if (theme.settings.afterAtc === 'page') {
          window.location.href = theme.routes.cart;
        } else {
          ProductForm.updateCartIcon(data);

          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          if (sections.some((id) => typeof data.sections?.[id] !== 'string' || !data.sections[id].trim())) {
            throw new Error('Cart sections unavailable');
          }

          if (this.cartDrawer) {
            await this.cartDrawer.renderContents(
              data,
              !quickAddDrawer && theme.settings.afterAtc === 'drawer'
            );
          } else if (window.location.pathname === theme.routes.cart) {
            const cartItems = document.querySelector('cart-items');
            if (cartItems) {
              if (cartItems.dataset.empty === 'true') {
                window.location.reload();
              } else {
                await cartItems.refresh();
              }
            }
          }
        }
      } catch (error) {
        const message = addConfirmed
          ? theme.strings.cartAddedRefreshError
          : responseError || theme.strings.cartAddUnconfirmed;
        this.setErrorMsgState(message || theme.strings.cartError, true);
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg?.textContent,
            addedToCart: addConfirmed
          }
        }));
      } finally {
        this.submitBtn.removeAttribute('aria-disabled');
        if (addConfirmed) {
          this.submitBtn.classList.add('is-success');
          const button = this.submitBtn;
          this.successTimer = setTimeout(() => {
            button.classList.remove('is-loading', 'is-success');
          }, 1400);
        } else {
          this.submitBtn.classList.remove('is-loading', 'is-success');
        }
      }
    }

    dispatchCartEvents(items, formData) {
      const quantity = Number(formData.get('quantity') || 1);
      items.forEach((item) => {
        const matchingSingleLine = items.length === 1
          && String(item.variant_id) === String(formData.get('id'))
          && Number.isInteger(quantity) && quantity > 0
          && Number.isInteger(item.quantity) && item.quantity >= quantity;
        const oldQuantity = matchingSingleLine ? item.quantity - quantity : null;
        const detail = { variantId: item.variant_id, key: item.key };
        if (oldQuantity > 0) {
          detail.oldQuantity = oldQuantity;
          detail.newQuantity = item.quantity;
        }
        this.dispatchEvent(new CustomEvent(oldQuantity > 0 ? 'on:line-item:change' : 'on:cart:add', {
          bubbles: true,
          detail
        }));
      });
    }

    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      const html = response.sections?.['cart-icon-bubble'];
      if (cartIconBubble && typeof html === 'string' && html.trim()) {
        cartIconBubble.innerHTML = html;
      }
    }

    setErrorMsgState(error = false, showCartLink = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg && error) {
        this.errorMsg = document.createElement('div');
        this.errorMsg.className = 'alert mb-8 bg-error-bg text-error-text js-form-error text-start';
        this.errorMsg.setAttribute('role', 'alert');
        this.form.prepend(this.errorMsg);
      }
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      this.errorMsg.textContent = '';
      if (error) {
        const errorArray = Array.isArray(error) ? error : [error];
        this.errorMsg.textContent = errorArray.join(' ');
        if (showCartLink) {
          const link = document.createElement('a');
          link.href = theme.routes.cart;
          link.className = 'link underline';
          link.textContent = theme.strings.viewCart;
          this.errorMsg.append(document.createTextNode(' '), link);
        }
      }
    }
  }

  customElements.define('product-form', ProductForm);
}

